var SimulateRemoteSecurityChecker = /** @class */ (function () {
    function SimulateRemoteSecurityChecker() {
    }
    SimulateRemoteSecurityChecker.prototype.isValid = function () {
        return Promise.resolve(true);
    };
    return SimulateRemoteSecurityChecker;
}());
export { SimulateRemoteSecurityChecker };
